import React, { useEffect, useRef, useState } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import Loading from 'apps/web_forms/components/commons/Loading';
import { PlaceHolder as StyledPlaceHolder } from 'apps/web_forms/components/commons/PlaceHolder';
import FormPageHeader from 'apps/web_forms/components/FormPageHeader';
import SearchBox from './SearchBox';

const StyledFormsContainer = styled.div`
  .form-elements-container {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    margin: 20px 0;
    gap: 20px;
    justify-content: space-between;
    padding-bottom: 2em;
  }
`;

const FormList = ({
  header,
  title,
  description,
  forms,
  loading,
  renderRightButton,
  children: renderListItem,
  searchBarSticky,
  searchBarWidth,
  className,
  id,
}) => {
  const [items, setItems] = useState(forms);
  const [ spinner, setSpinner ] = useState(loading);

  const searchQuery = useRef('');

  useEffect(() => {
    setItems(forms);
    search(searchQuery.current);
  }, [forms]);

  const search = (value) => {
    const lowerValue = value.toLowerCase().trim();
    searchQuery.current = lowerValue;
    const result = forms.filter(
      ({ title: itemTitle, description }) => itemTitle?.toLowerCase().indexOf(lowerValue) > -1 || description?.toLowerCase().indexOf(lowerValue) > -1
    );
    setItems(result);
  };

  useEffect(() => {
    if (!loading) {
      setSpinner(true);
      const timer = setTimeout(() => setSpinner(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [loading]);
  
  useEffect(() => {
    if (!loading && items.length) {
      setSpinner(false);
    }
  }, [loading, items]);

  return (
    <StyledFormsContainer id={id} className={className}>
      {(title || description) && (
        <FormPageHeader
          title={title}
          description={description}
          small={!header}
          renderRightButton={renderRightButton}
          renderToggleButton={false}
        />
      )}

      {spinner && <Loading />}

      <SearchBox
        id={`${id}_SearchBox`}
        callback={search}
        sticky={searchBarSticky}
      />

      {!spinner && forms && (
        <div className='form-elements-container'>
          {items.map(renderListItem)}
        </div>
      )}

      {!spinner && items.length === 0 && (
        <StyledPlaceHolder>No items found</StyledPlaceHolder>
      )}
    </StyledFormsContainer>
  );
};

FormList.propTypes = {
  header: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  forms: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  children: PropTypes.func.isRequired,
  renderRightButton: PropTypes.elementType,
  searchBarSticky: PropTypes.bool,
  searchBarWidth: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
};

FormList.defaultProps = {
  header: false,
  title: 'You probably meant to include a title',
  description: '',
  forms: null,
  loading: false,
  renderRightButton: () => {},
  searchBarSticky: false,
  searchBarWidth: '100%',
  className: 'form-list',
  id: 'FormList',
};

export default FormList;
